import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-h-small', 'IconLetterHSmall', [
  ['path', { d: 'M10 16v-8', key: 'svg-0' }],
  ['path', { d: 'M14 8v8', key: 'svg-1' }],
  ['path', { d: 'M10 12h4', key: 'svg-2' }],
]);
